export const obtenerPorcentaje = ({valor, rebajado}) => {

    let porcentaje = 100 - ((100 * rebajado) / valor)

    return porcentaje.toFixed(0)


}